import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { IGlobalStoreReducers } from './ReduxStore';

export interface IPrintDialogState {
    visible: boolean;
}

const initialState: IPrintDialogState = {
    visible: false,
};

const reducers = {
    update: (state: IPrintDialogState, action: PayloadAction<boolean>) => {
        state.visible = action.payload;
    },
};

export const printDialogSlice = createSlice({
    name: 'printDialog',
    initialState,
    reducers,
});

export const printDialogVisibility = (state: IGlobalStoreReducers) => state.printDialog.visible;

export const { update } = printDialogSlice.actions;

export default printDialogSlice.reducer;
